import { RpsScope } from "@/entities/physical-risk/model/rps-scope"
import { RpsRiskAxis } from "@/entities/population/model/rps-risk"
import { PhysicalRisk } from "@/entities/physical-risk/model/physical-risk.types"
import { User } from "@/redux/user.types"
import { v4 as uuid } from "uuid"

export const ESTABLISHMENT_ENTITY = "establishment"

interface EstablishmentScanElement {
  itemType?: "physicalRisk"
  id: string
  name: string
}

export interface EstablishmentScanResult {
  //Doublons (memes champs), meme intitule (contenu different) ; seuls dans leur resultat : risque sans famille,
  //risque psychosocial a passer dans la matrice RPS (axe propose)
  tag?: "Duplicate" | "SameName" | "NoFamily" | "ToRps"
  axis?: RpsRiskAxis
  //Doublons : meme evaluation pour tous les risques du groupe (absent des scans plus anciens)
  isSameEvaluation?: boolean
  id: string
  name: string
  items?: EstablishmentScanElement[]
}

export interface Establishment {
  scanResults: EstablishmentScanResult[]
  id: string
  name: string
  rpsScope: RpsScope
  industryCode: string //naf
  address: string
  codeEstablishment: string //siret
  x: number | null
  y: number | null
  isDisabled: boolean
  siteImageUploaded: boolean
  AccountId: string | null
  lastDuerp: Date | string | null
  lastPapripact: Date | string | null
  riskMax: PhysicalRisk | null
  //Niveau RPS global (evaluateRps) de la fonction la plus exposee du dernier document unique, et cette fonction
  rpsLevelMax: { level: number; populationName: string } | null
  riskDistribution: { label: string; color: string; count: number }[]
  Users: User[]
}

/**
 * Crée un Establishment vide, avec possibilité de surcharger les valeurs.
 */
export const createEmptyEstablishment = (overrides?: Partial<Establishment> & { users?: User[] }): Establishment => ({
  id: uuid(),
  name: "",
  scanResults: [],
  rpsScope: { mode: "unconfigured", attributeIds: [] },
  codeEstablishment: "",
  industryCode: "",
  address: "",
  x: null,
  y: null,
  isDisabled: false,
  siteImageUploaded: false,
  AccountId: null,
  lastDuerp: null,
  lastPapripact: null,
  riskMax: null,
  rpsLevelMax: null,
  riskDistribution: [],
  Users: [],
  ...overrides
})
